<template>

  <div style="background-image: url('/images/bg.jpg');background-size: cover">
  <CContainer class="d-flex content-center min-vh-100">
      <vue-snotify></vue-snotify>

      <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm v-on:submit.prevent="loginTo()">
                <div><img src="/images/icons/android-icon-48x48.png">  </div>
                <h3>Sayan Business</h3>
                <p class="text-muted">ورود به سامانه نرم افزاری شرکت</p>
                <CInput
                        v-model="userData.username"
                        placeholder="نام کاربری (موبایل/ایمیل)"
                  autocomplete="username email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                        v-model="userData.password"
                        placeholder="کلمه عبور"
                  type="password"
                  autocomplete="curent-password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col="6" class="text-left">
                    <CButton color="secondary" class="px-4" type="submit" style="background-color: #00acc1">ورود</CButton>
                  </CCol>
                  <CCol col="6" class="text-right">
                    <CButton color="" class="px-0 text-gray">فراموشی پسورد</CButton>
                    <CButton color="link" class="d-md-none">ثبت نام</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
          <CCard style="background-color: #00acc1"
            text-color="white"
            class="text-center py-5 d-sm-down-none"
            body-wrapper
          >
<!--            <div> Sayan Business CRM </div>-->

            <h4>ثبت نام در سایان </h4>
            <p>در صورتی که اطلاعات شما قبلا در سیستم ثبت نشده است، از طریق لینک زیر اقدام به ثبت نام نمایید</p>
            <CButton
              color="secondary"
              class="active mt-3"
            >
              ثبت نام
            </CButton>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
  </div>
</template>

<script>

  import axios from 'axios';


  export default {
  name: 'Login',
  data() {

    return {
      userData: {
        grant_type: "password",
        client_id: "cyan-business",
        client_secret: "v4lyYR70VzyDtcKwYm7hKw9O4HB2jtoK",
        username: "",
        password: ""
      },



      model: 'I\'m a text field',
      label: 'Hey!',
      hint: 'Customize me!',
      placeholder: '',
      shaped: false,
      outlined: false,
      rounded: false,
      solo: false,
      singleLine: false,
      filled: false,
      clearable: false,
      persistentHint: false,
      loading: false,
      flat: false,
      counterEn: false,
      counter: 0,
      dense: false,



      show1: false,
      show2: true,
      show3: false,
      show4: false,
      password: 'Password',
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      }
    }
  },
  methods: {

    loginTo() {

      const qs = require('qs');

      var app = this;

      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      //                var userData = app.userData;
      axios.post('realms/cyan/protocol/openid-connect/token',qs.stringify(app.userData) , config)
              .then(function (response) {
                localStorage.setItem('token', response.data.access_token);
                localStorage.setItem('refresh_token', response.data.refresh_token);

                // localStorage.setItem('id', response.data.user.id);
                // localStorage.setItem('name', response.data.user.name);
                // localStorage.setItem('family', response.data.user.mobile);
                // localStorage.setItem('email', response.data.user.email);
                // localStorage.setItem('state', response.data.user.status);

                //   if (response.data.user.roles.length !== 0)
                //       localStorage.setItem('role', response.data.user.roles[0].name);
                //
                //   localStorage.setItem('roles', JSON.stringify(response.data.user.roles));
                //
                // app.$store.state.roles = app.pluck(JSON.parse(localStorage.getItem('roles')), 'name')

                //                        app.setToken();
//                        console.log(response.data.token );
                // console.log(response.data.isAdmin)
//                        console.log(response);

                const auth = {
                  headers: {
                    Authorization: 'bearer ' + localStorage.getItem('token')
                  }
                };

                console.log(localStorage.getItem('token'));



                if (response.data.isAdmin == true) {
                  app.$router.push({
                    path: '/dashboard'
                  });
                }else{
                  app.$router.push({
                    path: '/dashboard'
                  });
                }
                // app.$snotify.info('کاربر عزیز خوش آمدید');



              })
              .catch(function (e) {
                console.log(e.response);
                //                        alert("unAuthorised");
                app.$snotify.error('  نام کاربری و پسورد به درستی وارد نشده است');

              });
    },


    pluck(array, key) {
      return array.map(function (obj) {
        return obj[key];
      });
    },






  }











}
</script>
